import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translation_de from './de';
import translation_en from './en';
import { createTranslationTable, flattenObject } from './until';

const resources = {
  de: translation_de,
  en: translation_en,
};

const deFlattened = flattenObject(translation_de);
const enFlattened = flattenObject(translation_en);

export const translationTable = createTranslationTable(
  [deFlattened, enFlattened],
  ['German', 'English'],
);

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      lookupLocalStorage: 'lng',
    },
    supportedLngs: ['de', 'en'],
    resources,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
